import { render, staticRenderFns } from "./MaterialReturnConfirmOutside.vue?vue&type=template&id=2da5e8a6&scoped=true"
import script from "./MaterialReturnConfirmOutside.vue?vue&type=script&lang=js"
export * from "./MaterialReturnConfirmOutside.vue?vue&type=script&lang=js"
import style0 from "./MaterialReturnConfirmOutside.vue?vue&type=style&index=0&id=2da5e8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da5e8a6",
  null
  
)

export default component.exports